import { Button } from '../../components/ui/button';
import { GraduationCap, ArrowRight } from 'lucide-react';

const CTABanner = () => {
  return (
    <section className="py-8 md:py-12" data-testid="cta-banner">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl p-10 md:p-16 text-center">
          {/* Split background - Cameroon left, Germany right */}
          <div className="absolute inset-0 flex">
            <div 
              className="w-1/2 bg-cover bg-center"
              style={{ backgroundImage: "url('/images/cameroon-city.jpg')" }}
            />
            <div 
              className="w-1/2 bg-cover bg-center"
              style={{ backgroundImage: "url('/images/germany-city.jpg')" }}
            />
          </div>
          
          {/* Black overlay */}
          <div className="absolute inset-0 bg-black/70" />
          
          {/* Diagonal divider line */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-px h-full bg-gradient-to-b from-transparent via-white/30 to-transparent" style={{ left: '50%' }} />
          </div>
          
          {/* Content */}
          <div className="relative z-10">
            {/* Logo badge */}
            <div className="inline-flex items-center gap-2 text-white/80 text-sm font-medium mb-6">
              <GraduationCap className="w-5 h-5" />
              <span>Speak&Move Global Institute</span>
            </div>
            
            {/* Main headline */}
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-8 max-w-3xl mx-auto" style={{ fontStyle: 'italic' }}>
              Votre voyage vers l'Allemagne commence par un simple pas.
            </h2>
            
            {/* CTA Button */}
            <Button 
              size="lg"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-primary hover:bg-white/90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all"
              data-testid="cta-banner-btn"
            >
              Prendre rendez-vous
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
